var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { class: _vm.fieldClass },
    [
      _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "md-select",
        {
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            multiple: _vm.multiple,
            required: _vm.required,
            "md-dense": _vm.dense,
            value: _vm.value,
            name: _vm.name,
            id: _vm.id,
            mdClass: _vm.callLocation
          },
          on: { input: _vm.onInput, "md-selected": _vm.onChange }
        },
        _vm._l(_vm.values, function(val, i) {
          return _c(
            "md-option",
            {
              key: i,
              attrs: {
                value: val.WalletId,
                selected: val.WalletId === _vm.value
              }
            },
            [_vm._v(_vm._s(val.Description))]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.clearable && _vm.value && _vm.value.length
        ? _c(
            "span",
            {
              staticClass: "md-select-clear-selection",
              on: { click: _vm.clearSelection }
            },
            [
              _c("md-icon", { staticClass: "clear-icon-size" }, [
                _vm._v("clear")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9e8e30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9e8e30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/SelectField2.vue
// module id = sOSP
// module chunks = 1